import { render } from "./HeaderData.vue?vue&type=template&id=ff6e1ed2"
import script from "./HeaderData.vue?vue&type=script&lang=js"
export * from "./HeaderData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__